import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";
import { cn } from "@/lib/utils";

type HeadlineSize = "huge" | "tall" | "medium" | "regular";

type HeadlineProps<TElementType extends ElementType> =
  ComponentPropsWithoutRef<TElementType> & {
    children: ReactNode;
    size?: HeadlineSize;
    as?: Extract<TElementType, "h1" | "h2" | "h3" | "h4" | "h5" | "p">;
  };

const Headline = <TElementType extends ElementType>({
  children,
  size = "tall",
  as,
  ...rest
}: HeadlineProps<TElementType>) => {
  const Element = as ?? "h2";

  return (
    <Element
      className={cn(
        "break-words",
        {
          ["text-title"]: size === "huge",
          ["text-headline-xl"]: size === "tall",
          ["text-headline-md"]: size === "medium",
          ["text-headline"]: size === "regular",
        },
        rest.className
      )}
    >
      {children}
    </Element>
  );
};

export { Headline };
export type { HeadlineSize };
